import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import HelpActionCreator from '../actions/HelpActionCreator';
import AccountsActionCreator from '../actions/AccountsActionCreator';
import InternetBankingActions from '../actions/InternetBankingActions';
import { getBrandId } from '../utils/BrandUtils';

const BUSINESS_FILE_PATH = '/content/{bank}/BiB_2.1.0.pdf';

const getTermsAndConditionsEndpoint =
  '/ibapi/v2/ref/content/tandcs/{bank}/latest';
const getTermsAndConditionsEndpointSMEUser =
  '/ibapi/v2/ref/content/smeobl/{bank}/latest';
const acceptTermsAndConditionsEndpoint =
  '/ibapi/v2/user/tandcs/{service-name}/{version}/accept';

const TermsConditionApiUtils = {
  getTcData(isSMEUser) {
    const tncEndPoint = isSMEUser
      ? getTermsAndConditionsEndpointSMEUser
      : getTermsAndConditionsEndpoint;
    const url = `${envConfig.apiBaseUrlPAAS}${tncEndPoint}`.replace(
      '{bank}',
      `${getBrandId(envConfig.brandId)}%20Web`
    );
    const method = 'GET';
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method,
        url,
        addAuthToken: true,
      },
      (body) => {
        HelpActionCreator.handleTcDataSuccess(body);
      },
      (error) => {
        HelpActionCreator.handleTcDataError(error);
      }
    );
  },

  getTextUrl(isSMEUser, dynamicFilePath) {
    const filePath = isSMEUser
      ? BUSINESS_FILE_PATH.replace('{bank}', getBrandId())
      : dynamicFilePath.replace('/banks', '');
    const url = `${envConfig.staticContentWebAppLink}${filePath}`;

    const method = 'GET';
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method,
        url,
        addAuthToken: true,
      },
      (body, status, text) => {
        HelpActionCreator.handleTcTextDataSuccess(url);
      },
      (error) => {
        HelpActionCreator.handleTcDataError(error);
      }
    );
  },
  acceptedTermsAndConditions(serviceName, version) {
    let url = envConfig.apiBaseUrlPAAS + acceptTermsAndConditionsEndpoint;
    url = url.replace('{service-name}', serviceName);
    url = url.replace('{version}', version);
    const method = 'PUT';
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method,
        url,
        addAuthToken: true,
      },
      () => {
        // Currently this only sends back a 200 so all we can do for now is go to next web task from product.
        // InternetBankingActions.navigateToWebTask('WEB-TIMELINE');
        AccountsActionCreator.handleAcceptTcSuccess();
      },
      () => {
        InternetBankingActions.navigateToWebTask('WEB-ERROR');
        // }
      }
    );
  },
};

export default TermsConditionApiUtils;
